/**
 * Load more for blog list
 * @type {HTMLElement}
 */

const loadMore = document.getElementById('loadmore');
const hid = [...document.querySelectorAll('.blog-list__item')];

if (loadMore) {

    console.log("gefunden")
    

    hid.splice(0, 4).forEach(
        elem => elem.classList.remove('hidden')
    );

    loadmore.addEventListener('click', function (e) {
        e.preventDefault();

        hid.splice(0, 3).forEach(
            elem => elem.classList.remove('hidden')
        )

        if (hid.length == 0) {
            loadMore.classList.add('hidden');
        }
    });
}
